<web-widget-breadcrumbs [widget]="widget()" [hideBreadcrumbs]="true" [isInSpecificSection]="isSpecific()" />

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            @let figure = form?.figure().value();
            <div class="form-group mb-0">
                <div class="col-xs-12">
                    <div class="figure-view-wrapper">
                        <div
                            class="figure-view"
                            [class.active]="figure === 'square'"
                            (click)="form.setFigure('square')"
                        >
                            <img src="./assets/img/websites/figure-variants/lpc-shape-1.svg" />
                        </div>

                        <div class="figure-view" [class.active]="figure === 'round'" (click)="form.setFigure('round')">
                            <img src="./assets/img/websites/figure-variants/lpc-shape-2.svg" />
                        </div>

                        <div
                            class="figure-view"
                            [class.active]="figure === 'triangle'"
                            (click)="form.setFigure('triangle')"
                        >
                            <img src="./assets/img/websites/figure-variants/lpc-shape-3.svg" />
                        </div>

                        <div class="figure-view" [class.active]="figure === 'star'" (click)="form.setFigure('star')">
                            <img src="./assets/img/websites/figure-variants/lpc-shape-4.svg" />
                        </div>

                        <div
                            class="figure-view"
                            [class.active]="figure === 'rhombus'"
                            (click)="form.setFigure('rhombus')"
                        >
                            <img src="./assets/img/websites/figure-variants/lpc-shape-5.svg" />
                        </div>

                        <div class="figure-view" [class.active]="figure === 'burst'" (click)="form.setFigure('burst')">
                            <img src="./assets/img/websites/figure-variants/lpc-shape-6.svg" />
                        </div>

                        <div
                            class="figure-view"
                            [class.active]="figure === 'diamond'"
                            (click)="form.setFigure('diamond')"
                        >
                            <img src="./assets/img/websites/figure-variants/lpc-shape-7.svg" />
                        </div>

                        <div
                            class="figure-view"
                            [class.active]="figure === 'hexagon'"
                            (click)="form.setFigure('hexagon')"
                        >
                            <img src="./assets/img/websites/figure-variants/lpc-shape-8.svg" />
                        </div>

                        <div
                            class="figure-view"
                            [class.active]="figure === 'horizontal-line'"
                            (click)="form.setFigure('horizontal-line')"
                        >
                            <img src="./assets/img/websites/figure-variants/lpc-shape-9.svg" />
                        </div>

                        <div class="figure-view" [class.active]="figure === 'blob'" (click)="form.setFigure('blob')">
                            <img src="./assets/img/websites/figure-variants/lpc-shape-10.svg" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group mb-10">
                <div class="col-xs-12">
                    <label class="checkbox-inline">
                        <input
                            type="checkbox"
                            (change)="setKeepProportions($event)"
                            [checked]="form?.keepProportions().value()"
                        />
                        {{ "control_keep_proportions" | translate }}
                    </label>
                </div>
            </div>

            <div class="form-group mb-10">
                <label class="col-xs-9 control-label">
                    {{ "control_background_color" | translate }}
                </label>
                <div class="col-xs-3">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="form?.backgroundColor().value()"
                        (colorChangeEvent)="setBackgroundColor($event)"
                    ></web-color-picker>
                </div>
            </div>

            @if (hasContourSettingSet.has(figure)) {
                <div class="form-group mb-15">
                    <label class="col-xs-9 control-label">
                        {{ "control_contour" | translate }}
                    </label>
                    <div class="col-xs-3 text-right">
                        <sp-switch [active]="form?.isBorder().value()" (toggleActiveEvent)="form.setIsBorder($event)" />
                    </div>
                </div>
            }

            @if (form?.isBorder().value() && hasContourSettingSet.has(figure)) {
                <div class="form-group mb-15">
                    <div class="col-xs-4">
                        <sp-input-num
                            suffixText="px"
                            [min]="SIZE_MIN"
                            [max]="30"
                            [value]="+form.borderWidth().value()"
                            (valueChange)="form.setBorderWidth($event)"
                        />
                    </div>
                    <div class="col-xs-6">
                        <select class="form-control" [formField]="form.borderStyle">
                            <option [value]="lineStyle.SOLID">{{ "control_solid" | translate }}</option>
                            <option [value]="lineStyle.DASHED">{{ "control_dashed" | translate }}</option>
                            <option [value]="lineStyle.DOTTED">{{ "control_dotted" | translate }}</option>
                        </select>
                    </div>
                    <div class="col-xs-2">
                        <web-color-picker
                            [color]="form.borderColor().value()?.toString()"
                            (colorChangeEvent)="setBorderColor($event)"
                            [positionLeft]="false"
                        />
                    </div>
                </div>
            }
        </div>

        @let shape = form?.figure().value();
        @let showShadowSettings = form?.isShadow().value() && shape && hasShadowSettingSet.has(shape);

        <div class="form-group" [class.mb-20]="!showShadowSettings" [class.mb-10]="showShadowSettings">
            <label class="col-xs-9 control-label"> {{ "control_shadow" | translate }} </label>
            <div class="col-xs-3 text-right">
                <sp-switch [active]="form?.isShadow().value()" (toggleActiveEvent)="form.setIsShadow($event)" />
            </div>
        </div>

        @if (showShadowSettings) {
            <sp-shadow-settings-signal-legacy
                [shadowSettings]="shadowSettingsValue()"
                (valueChangeEvent)="setShadowSettings($event)"
            />
        }

        @if (!isSpecific()) {
            <div class="form-row">
                <div class="form-group mb-10">
                    <div class="col-xs-12 device-toggle-wrapper">
                        <web-device-toggle />
                    </div>
                </div>
            </div>
        }

        <sp-extended-position-signal-settings
            [position]="zeroPosition()"
            [keepSizeProportions]="form?.keepProportions().value()"
            [isMobile]="isDeviceMobileSig()"
            [isTablet]="isDeviceTabletSig()"
            [parentId]="widget().columnId"
            (valueChangeEvent)="form.setPosition($event)"
        />

        <div class="form-group mb-0">
            <div class="col-xs-12">
                <hr class="panel-options-divider" />
            </div>
        </div>

        <web-widget-extended-hide-settings
            [hideOnDesktop]="form?.hideOnDesktop().value()"
            [hideOnTablet]="form?.hideOnTablet().value()"
            [hideOnMobile]="form?.hideOnMobile().value()"
            (hideOnDesktopChange)="form.setHideOnDesktop($event)"
            (hideOnTabletChange)="form.setHideOnTablet($event)"
            (hideOnMobileChange)="form.setHideOnMobile($event)"
        />

        <div class="form-group mb-0">
            <div class="col-xs-12">
                <hr class="panel-options-divider" />
            </div>
        </div>

        @if (!isSpecific()) {
            <div class="form-row">
                <sp-animation-settings-signal-legacy
                    [animation]="form?.animation().value()"
                    (valueChangeEvent)="form.setAnimation($event)"
                />
            </div>
        }

        <div [class.mt-20]="!isSpecific()">
            <web-custom-id [displayId]="form?.displayId()" (valueChangeEvent)="form?.setDisplayId($event)" />
        </div>
    </div>
</div>
